import React, { useState,useEffect } from 'react';
import { Button, Checkbox, InfoBox, Input } from 'components';
import { Modal, Form } from 'antd';
import '../basket-summary.less'
import 'components/Modal/modal.less'
import Promo from 'assests/icons/promo.icon';
import classNames from 'classnames';
import { usePackage } from 'context/package.context';


const AgreementModal = (props) => {
  const [modal, showModal] = useState(false);



  return (
      <React.Fragment>
            <Form.Item valuePropName="checked" name="informationContract" rules={[{ required: true }]}>
            <Checkbox
              text={<><a onClick={ () => showModal(true) }>Ön Bilgilendirme Formu ve Mesafeli Satış Sözleşmesi</a>’ni okudum ve kabul ediyorum.</>}/>
          </Form.Item>
          <Modal
            title="Ön Bilgilendirme"
            visible={ modal }
            onCancel={ () => showModal(false) }
            footer={[
              <div className="modal-action">
                <Button
                  shape="round"
                  type="ghost"
                  onClick={ () => showModal(false) }
                >
                  Vazgeç
                </Button>
                <Button
                  key="confirm"
                  type="primary"
                  onClick={ () => {
                    showModal(false)
                    props.formRef.current.setFieldsValue({
                      'informationContract': true
                    })
                  } }
                >
                  Onayla
                </Button>
              </div>
            ]}>
            <InfoBox htmlContent={props.agreement}
            />
          </Modal>
     </React.Fragment>
  )
}

export default AgreementModal